import type { Dispatch } from '@reduxjs/toolkit';
import {
    freemiumTypeParam,
    FreemiumTypes,
    isControlFreemium,
    isHardFreemium,
    isSoftFreemium,
} from 'reactApp/appHelpers/featuresHelpers/features/freemium';
import { BillingActions } from 'reactApp/modules/billing/billing.module';
import { openFreemiumFeaturesModal } from 'reactApp/sections/FamilyPage/FreemiumFeaturesModal/FreemiumFeaturesModal.helpers';
import type { FreemiumFeaturesModalData } from 'reactApp/sections/FamilyPage/FreemiumFeaturesModal/FreemiumFeaturesModal.types';
import { defaultModalProps } from 'reactApp/ui/FreemiumOnboardBanner/FreemiumOnboardBanner.helpers';
import { createFreemiumModalOpenHandler } from 'reactApp/ui/FreemiumTestUnlimitedModal/FreemiumTestUnlimitedModal.helpers';

export const openFreemiumHeavyFileModal = (dispatch: Dispatch) => {
    const modalProps: FreemiumFeaturesModalData = freemiumTypeParam
        ? defaultModalProps[freemiumTypeParam]
        : defaultModalProps[FreemiumTypes.control];

    const modalOpen = createFreemiumModalOpenHandler(dispatch, 'family_unlimited_trial_heavy_file');

    let title = modalProps.title;
    let text = modalProps.text;

    if (isSoftFreemium) {
        title = 'Загружайте тяжёлые файлы в Облако — с пробной подпиской';
        text =
            'Очень пригодится, если надо сохранить по-настоящему тяжёлый файл. \nНапример, сезон сериала, чтобы смотреть его офлайн в дороге';
    } else if (isHardFreemium) {
        title = 'Теперь можно загружать тяжёлые файлы в Облако';
        text =
            'Вы подключили пробную подписку. Она бесплатная, а возможности все настоящие. Пользуйтесь ей неделю — можно вместе с близкими';
    } else if (isControlFreemium) {
        title = 'Загружайте тяжёлые файлы в Облако — с пробной подпиской';
        text =
            'Очень пригодится, если надо сохранить по-настоящему тяжёлый файл.\nНапример, сезон сериала, чтобы смотреть его офлайн в дороге';
    }

    if (isHardFreemium) {
        dispatch(BillingActions.getFreemium());
    }

    openFreemiumFeaturesModal({
        ...modalProps,
        title,
        text,
        onButtonClick: modalOpen,
    });
};
